export default class Component {
  constructor() {
    this.onEvents = {
      // Bound events will go here
    };
  }

  load() {
    this.doEvents('load');
  }

  on(events, callback, priority = 10) {
    events.split(' ').map((event) => {
      this.onEvents[event] = this.onEvents[event] || [];
      this.onEvents[event].push({ callback, priority });
    });
  }

  doEvents(event, value) {
    const args = Array.prototype.slice.call(arguments, 1);

    if (this.onEvents[event]) {
      return this.onEvents[event]
      .sort((a, b) => a.priority === b.priority ? 0 : (a.priority < b.priority ? -1 : 1))
      .reduce((returnValue, e) => e.callback.call(this, value, args), value);
    }

    return value;
  }
}
